const VerboseCard = (props) => {
  const { img, uid, category, title, children } = props;

  return (
    <div
      id={`${uid}`}
      style={{
        color: "white",
      }}
    >
      <div
        style={{
          borderRadius: 10,
          overflow: "hidden",
          backgroundImage: `url(${img})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          width: 200,
          aspectRatio: 1,
        }}
      >
        {children}
      </div>
      <div>
        <h5>{category}</h5>
        <p>{title}</p>
      </div>
    </div>
  );
};

export default VerboseCard;
